import { useLocation as useTanstackLocation } from '@tanstack/react-router';
export function useLocation() {
    return useTanstackLocation();
}
